import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { HoldingDTO } from '../../AssetBucketingResults/api/useAssetBucketingResultsQuery';

export interface AssetDTO {
  id: string;
  title: string;
  value: number;
  holdings?: HoldingDTO[] | null;
  isHoldingsBucketInheritedFromAsset?: boolean | null;
  displayValue: number | null;
  networthValue: number;
  excludedFromNetworth: boolean;
  hasValueBeyondHoldings: boolean;
  chartValue: number;
}

export interface BucketDTO {
  title: string;
  description: string;
  assets: AssetDTO[];
}

export interface AssetBucketingDetailsDTO {
  headline: string;
  supportingText: string;
  buckets: BucketDTO[];
  unassignedAssets: AssetDTO[];
}

const fetchAssetBucketingDetails = async (clientId: string): Promise<AssetBucketingDetailsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/AssetBucketingLayout', {
      clientId,
    }),
  );
};

interface Params {
  clientId: string;
}

export const useAssetBucketingDetailsQuery = ({ clientId }: Params) => {
  return useQuery(
    queryKeys.assetBucketDetails(clientId),

    () => fetchAssetBucketingDetails(clientId),

    {
      cacheTime: 0,
    },
  );
};
